import './less/base.less';
import './services/markerclusterer.min';
import moment from 'moment';
import 'moment/locale/de';
import Vue from 'vue';
import Vuelidate from "vuelidate";
import Icon from './components/icon/Icon.vue';
import Modal from './components/modal/Modal.vue';
import SelectBox from './components/select-box/SelectBox.vue';
import MethodDropdown from './components/method-dropdown/MethodDropdown.vue';
import Spinner from './components/spinner/Spinner';
import HealthAdvisorWidget from './components/health-advisor-widget/HealthAdvisorWidget.vue';
import ClickOutside from './directives/ClickOutside';
import VueTouch from 'vue-touch';
import VTooltip from 'v-tooltip';
import BookingForm from './components/booking-widget/BookingForm.vue'
import Input from './ui/input/Input.vue'
import TextArea from './ui/textarea/TextArea.vue'
import CheckBox from './ui/checkbox/Checkbox.vue'
import Button from './ui/button/Button.vue'
import Select from './ui/select/Select.vue'
import IconRd from './ui/icon/Icon.vue'

Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(VTooltip);
Vue.use(Vuelidate);

moment.locale('de');

Vue.directive('click-outside', ClickOutside);

Vue.component('icon', Icon);
Vue.component('modal', Modal);
Vue.component('select-box', SelectBox);
Vue.component('method-dropdown', MethodDropdown);
Vue.component('spinner', Spinner);
Vue.component('health-advisor-widget', HealthAdvisorWidget);
Vue.component('booking-form', BookingForm);
Vue.component('input-rd', Input);
Vue.component('text-area-rd', TextArea);
Vue.component('checkbox-rd', CheckBox);
Vue.component('button-rd', Button);
Vue.component('select-rd', Select);
Vue.component('icon-rd', IconRd);


// TODO: include real localisation functionality later
Vue.filter('translate', function (value, keysArray) {
  let translated = value;

  if (window.gettext) {
    translated = window.gettext(value);
  }

  if (keysArray) {
    translated = translated.replace(/\{(\d+)\}/g, function (match, number) {
      return keysArray[number] || '';
    });
  }

  return translated;
});

/* eslint-disable no-new */
new Vue({
  el: '#health-advisor-widget-app',
  mounted() {
    this.$el.addEventListener('click', () => null, false);  // for normal behaviour of `click-outside` directive in the mobile iOS platforms
  }
});






// WEBPACK FOOTER //
// ./src/healthAdvisorWidget.js